export * from 'react-native-modal';

export { default } from 'react-native-modal';
